export class ScannedImage {
  imageUrl: any;
  keyString: string;
  country: string;
  isStateId: boolean;
  faceLandmark

  constructor(
    imageUrl: any,
    keyString: string,
    country: string,
    isStateId: boolean
  ) {
    this.imageUrl = imageUrl;
    this.keyString = keyString;
    this.country = country;
    this.isStateId = isStateId;
  }
}
